import { smoother } from './_gsap-core.js';
import { initGsapAnimations } from './_gsap-animations.js';
import {
   getURLParam,
   removeURLParam,
   scrollToId,
   setupDataScrollTo
} from './_gsap-utils.js';

document.addEventListener('DOMContentLoaded', () => {
   const body = document.body;

   // Aplica classe quando scroll passa de 50px
   smoother.scrollTrigger.scroller.addEventListener('scroll', () => {
      body.classList.toggle('scrolling', smoother.scrollTrigger.scroller.scrollY > 50);
   });

   // Inicializa animações com atributos [gsap]
   initGsapAnimations();

   // Faz scroll se houver ?scrollTo=alvo na URL
   const targetId = getURLParam('scrollTo');
   if (targetId) {
      setTimeout(() => {
         scrollToId(smoother, targetId);
         removeURLParam('scrollTo');
      }, 100);
   }

   // Faz scroll ao clicar em elementos com [data-scroll-to]
   setupDataScrollTo(smoother);
});
